// extracted by mini-css-extract-plugin
export default {"wrapper":"FetchingRepayment_wrapper__dIGzW"};